import { Box, BoxComponentProps } from 'reoil'
import logo from '../assets/images/logo.svg'
import avatar from '../assets/images/avatar.png'
import { RouteComponentProps } from '@reach/router'
import { MdChevronLeft } from 'react-icons/md'
import { useLayoutEffect, useRef, useState } from 'react'
import { useLoginValue } from '../store/loginState'
import { Backdrop } from '@material-ui/core'
import Login from './Login'
import goto from '../utils/goto'

interface NavigationProps {
  title?: string
  unFixed?: boolean
  hideAvatar?: boolean
}

const Navigation: React.FC<BoxComponentProps & RouteComponentProps & NavigationProps> = ({title, unFixed, hideAvatar, bg='white', ...props}) => {
  const domRef = useRef<HTMLDivElement | null>(null)
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  // 显示登录窗口
  const [showLogin, setShowLogin] = useState<boolean>(false)

  // 登录状态
  const loginValue = useLoginValue()
  
  useLayoutEffect(()=>{
    setRef(domRef.current)
  }, [domRef])

  const handleClickAvatar = ()=>{
    if(!loginValue.isLogin){
      setShowLogin(true)
    }else {
      goto('/user')
    }
  }

  return(
    <Box className='Navigation' stretch height={ref?.offsetHeight}>
      <Box flex={1} row center p={3} py={2} position={!unFixed ? 'fixed' : 'relative'} left={0} fullWidth borderBox ref={domRef} style={{zIndex: 999}} bg={bg} borderBottom='divider' {...props}>
        <Box maxWidth={800} flex={1} stretch rowBetween row>
          {title ?
          <Box row center onClick={()=>goto(-1)} pointer>
            <Box className='navback' mr={2}><MdChevronLeft size={22} /></Box>
            <Box className='title' lineClamp={1}><h2 style={{fontSize: 20}}>{title}</h2></Box>
          </Box> :
          <Box className='logo' pointer><img src={logo} alt=""/></Box>}

          {!hideAvatar && (
            !loginValue.isLogin ?
            <Box bg='primary' color='white' p={2} px={3} fontSize={14} onClick={handleClickAvatar} borderRadius={20} pointer style={{whiteSpace: 'nowrap'}}>登录</Box> :
            <Box className='avatar' pointer onClick={handleClickAvatar} size={42} fit='cover' borderBox border='1px solid white' borderRadius='50%'><img src={loginValue.avatar || avatar} alt=""/></Box>
          )}
        </Box>
      </Box>

      <Backdrop open={showLogin} style={{zIndex: 1000}} onClick={()=>setShowLogin(!showLogin)}>
        <Login onSuccess={token=>setShowLogin(false)} />
      </Backdrop>

    </Box>
  )
}

export default Navigation
